<template>
 <!-- class="bg-dark" -->
<q-layout view="lHr LpR lFr" id="top_page"
        v-if="user && app_state().ready">


    <DrawerLeft />

    <DrawerRight v-if="isAdmin" />

    <HeaderApp />

    <q-page-container>

            <!-- <q-scroll-area :style="'height:600px!important; '+height" -->
            <!-- <q-scroll-area :style="'height:'+height+'px!important'"
                :thumb-style="app_state().scrollarea_bar_style_right"> -->
            <!-- <q-scroll-area class="fit"
                :thumb-style="app_state().scrollarea_bar_style_right"> -->

        <AlertInLayout />


        <!-- <UserHasManyShops v-if="user.has_many_shops && ! (/profile|create|edit/).test(route().current())" /> -->


        <q-page padding>

            <transition appear name="slide-fade" mode="out-in">

                <main v-if="app_state().show_page" class="row q-mb-xl q-pb-xl relative-position q-col-gutter-md">

                    <!-- <div v-if="app.show_overlay" class="overlay bg-dark opacity-75"></div> -->

                    <slot></slot>
                </main>
                <!-- <div v-else class="row items-center justify-content-center" key="spinner">
                    <q-spinner-oval class="col" size="52" />
                </div> -->
            </transition>


            <!-- <q-page-sticky position="bottom-right" :scroll-offset="150" :offset="[60,10]">
                <q-btn :size="$_isMobile ? 'sm' : 'md'" icon="keyboard_arrow_down" class="q-animate--scale q-pa-xs"
                        round color="secondary" text-color="white"
                        @click="scrollTo('bottom')" />
            </q-page-sticky>
            <div id="bottom"></div> -->

            <q-page-scroller :duration="50" position="bottom-right" :scroll-offset="150" :offset="[10,10]">
            <!-- <q-page-scroller :duration="50" position="bottom-right" :scroll-offset="150" :offset="[prev_uri ? 60 : 10 ,10]"> WITH BACK BUTTON -->
                <q-btn :size="$_isMobile ? 'sm' : 'md'" icon="keyboard_arrow_up" class="q-animate--scale q-pa-xs"
                        round color="secondary" text-color="white" />
                        <!-- @click="showOverlay(); hideOverlay()" /> -->
            </q-page-scroller>


<!-- BACK BUTTON -->
        <!-- <q-page-sticky position="bottom-right" :scroll-offset="150" :offset="[10,10]">
                <q-btn v-if="prev_uri" @click="back()"
                        icon="chevron_left" color="primary" :size="$_isMobile ? 'sm' : 'md'" round class="q-mx-xs" />
        </q-page-sticky> -->

        </q-page>
        <!-- </q-scroll-area> -->

        <!-- <Flash /> -->
    </q-page-container>


    <!-- <MyGuidedTour v-show="app_state().show_page" /> -->


    <!-- <DirectMsgForm v-if="app_state().open_direct_msg_form" /> -->

    <!-- <UpgradeAppVersionUser v-if="user && (user.app_version != app_state().appversion)" /> -->
    <UpgradeAppVersionUser v-if="user" />

    <DetectOnline />

</q-layout>
</template>

<script setup>
import { /* $ac,  */app_state } from '@helpers'

import DrawerLeft from '@comp/DrawerLeft.vue'
import DrawerRight from '@comp/DrawerRight.vue'
import AlertInLayout from '@comp/partials/AlertInLayout.vue'
import UpgradeAppVersionUser from '@comp/partials/UpgradeAppVersionUser.vue'
import DetectOnline from '@comp/DetectOnline.vue'
// import MyGuidedTour from '@comp/partials/MyGuidedTour.vue'
// import DirectMsgForm from '@comp/DirectMsgForm.vue'

// import UserHasManyShops from '@comp/UserHasManyShops.vue'
</script>
